import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { PremiumFeatureConfig, PremiumFeatureKey, PremiumOnboardingSlide, PremiumPlan, PremiumSlide } from "types/premium.types"
import { getActivePremiumFeatures, getPremiumSlidesForActiveFeatures } from "utils/PremiumUtils"

type Premium = {
  showPremiumOnboarding: boolean;
  currentPremiumOnboardingSlide: PremiumOnboardingSlide;
  plans: PremiumPlan[] | null;
  expireDate: Date | string | null;
  hasSeenPremiumBanner: boolean;
  lastSeenPremiumBanner: PremiumOnboardingSlide;
  activePremiumFeatures: Partial<Record<PremiumFeatureKey, PremiumFeatureConfig>>;
  premiumSlidesForActiveFeatures: PremiumSlide[];
}

const initialState = {
  showPremiumOnboarding: false,
  currentPremiumOnboardingSlide: -1,
  plans: null,
  expireDate: null,
  hasSeenPremiumBanner: false,
  lastSeenPremiumBanner: -1,
  activePremiumFeatures: {},
  premiumSlidesForActiveFeatures: []
} as Premium

export const premium = createSlice({
  name: "premium",
  initialState: initialState,
  reducers: {
    updateShowPremiumOnboarding: (state, action: PayloadAction<boolean>) => {
      state.showPremiumOnboarding = action.payload
      state.currentPremiumOnboardingSlide = action.payload ? 0 : -1
    },
    updatePremiumCurrentOnboardingSlide: (state, action: PayloadAction<PremiumOnboardingSlide>) => {
      state.currentPremiumOnboardingSlide = action.payload
    },
    updatePremiumPlans: (state, action: PayloadAction<PremiumPlan[] | null>) => {
      state.plans = action.payload
    },
    updateExpireDate: (state, action: PayloadAction<string | null>) => {
      state.expireDate = action.payload
    },
    updateHasSeenPremiumBanner: (state, action: PayloadAction<boolean>) => {
      state.hasSeenPremiumBanner = action.payload
    },
    updateLastSeenPremiumBanner: (state, action: PayloadAction<PremiumOnboardingSlide>) => {
      state.lastSeenPremiumBanner = action.payload
    },
    updateActivePremiumFeatures: (state) => {
      state.activePremiumFeatures = getActivePremiumFeatures()
    },
    updatePremiumSlidesForActiveFeatures: (state) => {
      state.premiumSlidesForActiveFeatures = getPremiumSlidesForActiveFeatures()
    },
    resetPremiumSlice: () => structuredClone(initialState)
  }
})

export const {
  updateShowPremiumOnboarding,
  updatePremiumCurrentOnboardingSlide,
  updatePremiumPlans,
  updateExpireDate,
  updateLastSeenPremiumBanner,
  updateHasSeenPremiumBanner,
  updateActivePremiumFeatures,
  updatePremiumSlidesForActiveFeatures,
  resetPremiumSlice
} = premium.actions

export default premium.reducer
